"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Portal", {
  enumerable: true,
  get: function () {
    return _Portal.default;
  }
});
Object.defineProperty(exports, "getPortalRoot", {
  enumerable: true,
  get: function () {
    return _Portal2.getPortalRoot;
  }
});

var _Portal = _interopRequireDefault(require("./Portal"));

var _Portal2 = require("./Portal.utils");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvUG9ydGFsL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IGRlZmF1bHQgYXMgUG9ydGFsIH0gZnJvbSAnLi9Qb3J0YWwnXG5leHBvcnQgdHlwZSB7IFBvcnRhbFByb3BzLCBQb3J0YWxSb290SWQgfSBmcm9tICcuL1BvcnRhbC50eXBlcydcbmV4cG9ydCB7IGdldFBvcnRhbFJvb3QgfSBmcm9tICcuL1BvcnRhbC51dGlscydcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFFQSJ9